import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TransferPanel.module.css';

export type TransferTabType = 'queue' | 'agent' | 'number';

interface TransferPanelTabsProps {
  activeTab: TransferTabType;
  isLoading: boolean;
  onTabChange: (tab: TransferTabType) => void;
}

export function TransferPanelTabs({ activeTab, isLoading, onTabChange }: TransferPanelTabsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.tabs}>
      <button
        className={`${styles.tab} ${activeTab === 'queue' ? styles.activeTab : ''}`}
        onClick={() => onTabChange('queue')}
        disabled={isLoading}
      >
        {t('call:transfer.toQueue')}
      </button>
      <button
        className={`${styles.tab} ${activeTab === 'agent' ? styles.activeTab : ''}`}
        onClick={() => onTabChange('agent')}
        disabled={isLoading}
      >
        {t('call:transfer.toAgent')}
      </button>
      <button
        className={`${styles.tab} ${activeTab === 'number' ? styles.activeTab : ''}`}
        onClick={() => onTabChange('number')}
        disabled={isLoading}
      >
        {t('call:transfer.toNumber')}
      </button>
    </div>
  );
}
